import createBaseRendererServerMessages from "./createBaseRendererServerMessages";

export default createBaseRendererServerMessages({
  name: "zadostiStav",
  kodKey: "stav",
  placeholderText: "POTVRZENÝ"
});
